module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVBAMAAACAghKHAAAAElBMVEUAAAA4aOc4a+g4bOg4bOc4bOhazqNzAAAABXRSTlMAIN+/QPENKGUAAAAlSURBVAjXYxAWYAABU0UwJRQE5jKqksF1DYbyoHJEchC2Q90CAB8oB2NRyhdOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/arrow.png
// module id = IK4y
// module chunks = 44